import { TABLET_M_BP } from "@website-builder/utilities-index";
import styled from "styled-components";

export const BlogBannerWrapper = styled.div`
	text-decoration: none;
	display: block;
	${({ isIndexPage }) => (isIndexPage ? "*{cursor:pointer;}" : "")}

	.date-of-publishing {
		color: var(--secondary-gray-dark);
	}

	.blog-image {
		object-fit: cover;
		width: 100%;
		max-width: 800px;
		${({ bannerMaxHeight }) =>
			bannerMaxHeight ? `max-height:${bannerMaxHeight}px;` : ""}
		border-radius: 8px;
	}

	.blog-banner-text-content {
		display: flex;
		flex-direction: ${({ isIndexPage }) =>
			isIndexPage ? "column-reverse" : "column"};
		gap: 1rem;

		@media only screen and (max-width: ${TABLET_M_BP}px) {
			flex-direction: column-reverse;
			.blog-description {
				display: none;
			}
		}
	}
`;
